module.exports = __webpack_public_path__ + "static/img/13suanwoyige.3c7bca6a.gif";